
import { fromJS } from 'immutable';
import actionTypes from '../../actions/actionTypes'
import requestStatus from '../../constants/requestStatus'
import {returnStateIfNoAction } from '../helpers';

const getInitState = weeks => {
    return fromJS({
        status: requestStatus.INITIALIZED,
        error: null,
        weeks: weeks,
        currentWeek: weeks[1]
    })
}


const onGet = (state, action) =>  state.set('status', requestStatus.REQUEST_PENDING)
                                        .set('error', '')

const onGetSuccess = (state, action) => {
    const pushData = action.payload

    delete pushData.status
    delete pushData.error

    return fromJS({
        status: requestStatus.REQUEST_SUCCESS,
        error: '',
        ... pushData
    })
}

const onError = (state, action) => state.set('status', requestStatus.REQUEST_ERROR)
                                        .setIn(['error'], action.payload.errorMessage)

const pushListReducer = weeks => (state = getInitState(weeks), action) => {
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.PUSH_DATA_GET_REQUEST:
            return onGet(state);
        case actionTypes.PUSH_DATA_GET_SUCCESS:
            return onGetSuccess(state, action).set('hasChanges', false);
        case actionTypes.PUSH_DATA_GET_ERROR:
            return onError(state, action);
        default:
            return state;
    }
}


export default pushListReducer;